import { ColumnsProps } from "@/components/table";
import {
  DATE_FORMAT_TABLE_SHORT,
  DATETIME_FORMAT_TABLE_SHORT,
} from "@/constants/date";
import { getExpenseTypeColor } from "@/pages/Expenses/RecordExpense/utils/expenseDrafts";
import { Expense } from "@/types/expense";
import { formatCurrency } from "@/utils/currency";
import { formatQuantity } from "@/utils/numbers";
import { Tag } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { ColumnsType } from "antd/es/table";

export const getColumns = ({
  record,
  filterOptions,
  filterValues,
  getSortOrder,
}: ColumnsProps<Expense>): ColumnsType<Expense> => [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    hidden: !record?.some((item) => item.date) && !filterValues?.date,
    sorter: true,
    sortOrder: getSortOrder?.("date"),
    render: (date: string) => dayjs(date).format(DATE_FORMAT_TABLE_SHORT),
  },
  {
    title: "Type",
    dataIndex: ["expense_type", "name"],
    key: "expense_type_id",
    sorter: true,
    sortOrder: getSortOrder?.("expense_type.name"),
    filters: filterOptions?.expense_type_id,
    filterSearch: true,
    filteredValue: filterValues?.expense_type_id || null,
    render: (name: string) => {
      const color = getExpenseTypeColor(name);
      return <Tag color={color}>{name}</Tag>;
    },
  },
  {
    title: "Description",
    dataIndex: ["description", "name"],
    key: "description_id",
    hidden:
      !record?.some((item) => item.description) &&
      !filterValues?.description_id,
    sorter: true,
    sortOrder: getSortOrder?.("description.name"),
    filters: filterOptions?.description_id,
    filterSearch: true,
    filteredValue: filterValues?.description_id || null,
    render: (name: string) => name || "-",
  },
  {
    title: "Price",
    dataIndex: "price",
    key: "price",
    hidden: !record?.some((item) => item.price) && !filterValues?.price,
    sorter: true,
    sortOrder: getSortOrder?.("price"),
    render: (price: number) => formatCurrency(price),
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    key: "quantity",
    hidden: !record?.some((item) => item.quantity) && !filterValues?.quantity,
    sorter: true,
    sortOrder: getSortOrder?.("quantity"),
    render: (quantity: number) =>
      quantity ? formatQuantity(quantity, 2) : "-",
  },
  {
    title: "Unit",
    dataIndex: ["unit", "name"],
    key: "unit_id",
    hidden: !record?.some((item) => item.unit) && !filterValues?.unit_id,
    sorter: true,
    sortOrder: getSortOrder?.("unit.name"),
    filters: filterOptions?.unit_id,
    filterSearch: true,
    filteredValue: filterValues?.unit_id || null,
    render: (name: string) => name || "-",
  },
  {
    title: "Supplier",
    dataIndex: ["supplier", "name"],
    key: "supplier_id",
    hidden:
      !record?.some((item) => item.supplier) && !filterValues?.supplier_id,
    sorter: true,
    sortOrder: getSortOrder?.("supplier.name"),
    filters: filterOptions?.supplier_id,
    filterSearch: true,
    filteredValue: filterValues?.supplier_id || null,
    render: (name: string) => name || "-",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    sorter: true,
    sortOrder: getSortOrder?.("created_at"),
    render: (date: Dayjs) => dayjs(date).format(DATETIME_FORMAT_TABLE_SHORT),
  },
  // TODO: Hide for now
  // {
  //   title: "Actions",
  //   key: "actions",
  //   width: 80,
  //   render: (_: string, record: Expense) => (
  //     <Tooltip title="View Details">
  //       <Button
  //         type="link"
  //         icon={<EyeOutlined />}
  //         onClick={() => onView(record)}
  //         size="small"
  //       />
  //     </Tooltip>
  //   ),
  // },
];
